<gbc-topbar [title]="'core.ams-description-title' | translate" (headerClick)="navigateToRoot()">
  <gbc-topbar-dropdown data-hj-suppress [placeholder]="(userName$ | async) || ('app-sign-in' | translate)" id="topbar-dropdown">

    @if ((currentUser$ | async) === null) {
      <button gbc-topbar-dropdown-item (click)="signin()">
        {{'app-sign-in' | translate}}
      </button>
    }

    @if (accountAvailable$ | async) {
      <button gbc-topbar-dropdown-item
        [routerLink]="'/account'"
        angulartics2On="click"
        angularticsAction="accountClicked"
        angularticsCategory="userMenu">
        {{'app-account-page.title' | translate}}
      </button>
    }

    @if (userManagementAvailable$ | async) {
      <button gbc-topbar-dropdown-item
        [routerLink]="'/users'"
        angulartics2On="click"
        angularticsAction="userManagementClicked"
        angularticsCategory="userMenu">
        {{'users-page.title' | translate}}
      </button>
    }

    @if (currentUser$ | async) {
      <button gbc-topbar-dropdown-item
        (click)="logout()"
        angulartics2On="click"
        angularticsAction="logoutClicked"
        angularticsCategory="userMenu">
        {{'app-menu-logout' | translate}}
      </button>
    }

    <button gbc-topbar-dropdown-item
            (click)="renewCookies()"
            angulartics2On="click"
            angularticsAction="chooseCookies"
            angularticsCategory="userMenu">
      {{'app-menu-cookies' | translate}}
    </button>

  </gbc-topbar-dropdown>

  <button gbc-current-language>
    {{currentLanguage$ | async}}
  </button>

</gbc-topbar>

<div class="outlet-container">
  <gbc-page-spinner>
    <div class="outlet">
      <router-outlet></router-outlet>
    </div>
  </gbc-page-spinner>
</div>
